// @ts-nocheck
import React, { useCallback, useMemo } from 'react';
import { TextField } from '@mui/material';

import { ReactComponent as DropdownArrow } from '../../../../assets/images/DropdownArrow.svg';
import PropTypes from 'prop-types';
import { EMPTY_ARRAY } from '../../../../const/CommonConst';
import Multiselect from '../../Multiselect';

const handleGetOptionLabel = (option) => option?.label;
const handleIsOptionEqualToValue = (option, val) =>
  option?.value === val?.value;

const GroupMultiSelectFieldComponent = ({
  value,
  label,
  titleLabel,
  onChange,
  groupList = EMPTY_ARRAY,
  isLoadingConstraints = false,
}) => {
  const groupOptions = useMemo(() => {
    return groupList?.map((group) => ({
      label: group?.groupName,
      value: group?.id,
    }));
  }, [groupList]);

  const selectedGroups = useMemo(() => {
    if (!value) return [];
    return groupOptions?.filter((group) => {
      return value?.includes(group?.value) || value?.includes(group?.label);
    });
  }, [value, groupOptions]);

  const handleChange = useCallback(
    (newSelectedGroups) => {
      onChange(newSelectedGroups?.map((group) => group?.value));
    },
    [onChange]
  );

  const renderGroupSelectTextField = useCallback(
    (params) => {
      return (
        <TextField
          {...params}
          label={label}
          title={titleLabel}
          placeholder="Select group"
          InputProps={{
            ...params.InputProps,
            placeholder: 'Select group',
          }}
          InputLabelProps={{
            shrink: true,
          }}
        />
      );
    },
    [label, titleLabel]
  );

  return (
    <Multiselect
      disabled={isLoadingConstraints}
      disableCloseOnSelect
      options={groupOptions || []}
      value={selectedGroups || null}
      getOptionLabel={handleGetOptionLabel}
      isOptionEqualToValue={handleIsOptionEqualToValue}
      onChange={handleChange}
      noOptionsText="No options available"
      popupIcon={<DropdownArrow />}
      renderInput={renderGroupSelectTextField}
    />
  );
};
GroupMultiSelectFieldComponent.propTypes = {
  label: PropTypes.string.isRequired,
  titleLabel: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  groupList: PropTypes.arrayOf(
    PropTypes.shape({
      groupName: PropTypes.string.isRequired,
      id: PropTypes.number.isRequired,
      // Add other group properties as needed
    })
  ),
  isLoadingConstraints: PropTypes.bool,
};

export default GroupMultiSelectFieldComponent;
